module.exports = __webpack_public_path__ + "static/media/hundred_percent.8aac9ae6.png";